// @flow

import React from 'react';
import * as Immutable from 'immutable';
import Item from './Item';
import { Loader } from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import type { ThreadMessage } from '../../types';

type Props = {
  messages: Immutable.List<ThreadMessage>,
  lastReadIndex?: number,
  isFetching: boolean,
  onRequestPreviousMessages: (scrollHeight: number) => void,
  onReadUpToIndex: (index: number) => void,
  onDisplayMessage: (message: ThreadMessage, resource: BucketResource) => void,
};

const groupMessagesByDate = (messages: Immutable.List<ThreadMessage>) => {
  const byDate = messages
    .groupBy(m => m.day)
    .toMap()
    .mapEntries(([date, messages]) => {
      return [date, messages.get(0)];
    })
    .toJS();

  return messages.map(message => {
    const isFirstByDate = byDate[message.day].index === message.index;
    return {
      ...message,
      isFirstByDate,
    };
  });
};

class InfiniteList extends React.Component<Props> {
  onEnterWaypoint = ({ event }) => {
    const { isFetching } = this.props;
    if (isFetching) {
      return;
    }

    if (event != null) {
      this.props.onRequestPreviousMessages(event.srcElement.scrollHeight);
    }
  };

  render() {
    const {
      messages,
      lastReadIndex,
      isFetching,
      onDisplayMessage,
    } = this.props;

    const messagesByDate = groupMessagesByDate(messages);

    const isMessageUnread = (message: ThreadMessage): boolean => {
      return lastReadIndex != null && message.index > lastReadIndex;
    };

    return (
      <div className="infinite-list-container">
        <LoaderItem show={isFetching} />
        {!isFetching && (
          <Waypoint onEnter={this.onEnterWaypoint} threshold={2.0} />
        )}
        {messagesByDate.map(message => (
          <Item
            key={message.index}
            message={message}
            isUnread={isMessageUnread(message)}
            onDisplayMessage={onDisplayMessage}
          />
        ))}
      </div>
    );
  }
}

const LoaderItem = ({ show }) => {
  return (
    <div className={`loader-container ${show ? 'show' : ''}`}>
      <Loader active inline="centered" />
    </div>
  );
};

export default InfiniteList;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/InfiniteList.js